import Cookies from 'js-cookie';
export default function getCsrfCode() {
    var skey = Cookies.get('skey') || Cookies.get('p_skey');
    if (!skey) {
        return '';
    }
    var hash = 5381;
    for(var i = 0, len = skey.length; i < len; i += 1){
        hash += (hash << 5) + skey.charCodeAt(i);
    }
    return hash & 2147483647;
};
